module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-push-bomb enem/p-push-bomb enem1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-push-bomb enem/p-push-bomb enem2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-push-bomb enem/p-push-bomb enem3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-push-bomb enem/p-push-bomb enem4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-push-bomb enem/p-push-bomb enem5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-push-bomb enem/p-push-bomb enem6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-ready-bomb enem/p-ready-bomb enem1_.png").default
        }
    ]
}
